var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconInvisible(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_19286_97825)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.38586 5.12448L9.5331 7.27172L9.54333 7.15925C9.54333 6.03108 8.6265 5.11426 7.49834 5.11426L7.38586 5.12448Z",
    fill: "#2B2F38"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.49825 3.75102C9.37964 3.75102 10.9066 5.27796 10.9066 7.15935C10.9066 7.59902 10.818 8.01824 10.6646 8.40337L12.6585 10.3972C13.6878 9.53834 14.4989 8.42724 15 7.15935C13.8173 4.16686 10.91 2.04688 7.49828 2.04688C6.54394 2.04688 5.63053 2.21728 4.78186 2.52403L6.25425 3.993C6.63935 3.84305 7.05857 3.75102 7.49825 3.75102Z",
    fill: "#2B2F38"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.681653 1.89353L2.23584 3.44773L2.54601 3.75789C1.42127 4.63724 0.531697 5.8063 0 7.15938C1.17929 10.1519 4.08998 12.2719 7.49831 12.2719C8.5549 12.2719 9.56375 12.0674 10.4874 11.6958L10.7771 11.9856L12.7642 13.976L13.6333 13.1103L1.55077 1.02441L0.681653 1.89353ZM4.45127 5.65973L5.50444 6.7129C5.47377 6.85947 5.45332 7.00601 5.45332 7.15938C5.45332 8.28755 6.37014 9.20437 7.49831 9.20437C7.65168 9.20437 7.79825 9.18392 7.9414 9.15325L8.99457 10.2064C8.54125 10.4314 8.03684 10.5677 7.49831 10.5677C5.61692 10.5677 4.08998 9.04077 4.08998 7.15938C4.08998 6.62088 4.22632 6.11644 4.45127 5.65973Z",
    fill: "#2B2F38"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_19286_97825"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 15,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconInvisible);
export default __webpack_public_path__ + "static/media/icon-invisible.d1226c6b0cfff318a462118e1ddc5c40.svg";
export { ForwardRef as ReactComponent };